import Vue from 'vue';
import { defineStore } from 'pinia';
import _ from 'lodash';

import ConversationApi from '@/extensions/chatbot/store/api/conversation';

export const useChatbotConversationStore = defineStore('chatbotConversation', {
    state: () => ({
        loading: true,
        conversationsPaginated: {
            variables: {
                order: 'created_at',
                direction: 'desc',
                paginationSizes: [25, 50, 100]
            },
            filters: {},
            pageInfo: {
                total: 0,
                perPage: 25,
                currentPage: 1,
                lastPage: 0
            },
            allColumns: [],
            activeColumns: [],
            showFilters: false,
            defaultSort: null,
            link: {},
            items: []
        },
        currentConversation: null,
        currentConversationLoading: false
    }),

    actions: {
        addPaginatedConversationsToState(data) {
            this.conversationsPaginated.items = data.items;
            this.conversationsPaginated.pageInfo = _.cloneDeep(data.pageInfo);
            this.conversationsPaginated.allColumns = _.cloneDeep(data.config.allColumns);
            this.conversationsPaginated.link = _.cloneDeep(data.config.link);
            this.conversationsPaginated.showFilters = _.get(data.config, 'showFilters') || false;
            this.conversationsPaginated.defaultSort = _.get(data.config, 'defaultSort') || null;
        },

        defineActiveColumns(activeColumnKeys) {
            const activeColumns = [];
            _.each(this.conversationsPaginated.allColumns, column => {
                const allowed = _.find(activeColumnKeys, value => column.key === value);
                if (allowed) activeColumns.push(column);
            });

            if (activeColumns.length) {
                this.conversationsPaginated.activeColumns = activeColumns;
            }
        },

        defineItemsPerPage(perPage) {
            this.conversationsPaginated.pageInfo.perPage = perPage;
        },

        defineCurrentPage(currentPage) {
            this.conversationsPaginated.pageInfo.currentPage = currentPage;
        },

        defineFilterValue({ key, value }) {
            if (value.match === '' && value.like === '' && value.from === '' && value.to === '' && value.in.length === 0) {
                Vue.delete(this.conversationsPaginated.filters, key);
            } else {
                Vue.set(this.conversationsPaginated.filters, key, value);
            }
        },

        defineSorting({ key, value }) {
            this.conversationsPaginated.variables.order = key;
            this.conversationsPaginated.variables.direction = value;
        },

        defineFilterVisibility(value) {
            this.conversationsPaginated.showFilters = value;
        },

        updateLoading(value) {
            this.loading = value;
        },

        setCurrentConversation(conversation) {
            this.currentConversation = conversation;
        },

        setCurrentConversationLoading(value) {
            this.currentConversationLoading = value;
        },

        fetchConversationsPaginated() {
            return ConversationApi.fetchConversationsPaginated(this.conversationsPaginated).then(data => {
                this.addPaginatedConversationsToState(data);

                const activeColumnKeys = _.map(data.config.activeColumnKeys, 'key');
                this.defineActiveColumns(activeColumnKeys);
            });
        },

        fetchMessage(id) {
            return ConversationApi.fetchMessage(id);
        },

        fetchConversation(id) {
            this.setCurrentConversationLoading(true);
            return ConversationApi.fetchConversation(id)
                .then(conversation => {
                    this.setCurrentConversation(_.cloneDeep(conversation));
                    this.setCurrentConversationLoading(false);
                    return conversation;
                })
                .catch(err => {
                    this.setCurrentConversationLoading(false);
                    throw err;
                });
        }
    }
});
